// import { combineReducers } from "redux";
// import auth from "./auth";
// import alert from "./alert";
// import snackBar from "./snackbar";
// import textEditor from "./textEditor";

// const rootReducer = combineReducers({ auth, alert, textEditor, snackBar });

// export default rootReducer;

// src/reducers/index.js
import authReducer from "./authSlice"; // Adjust paths as needed
import alertReducer from "./alertSlice";
import snackBarReducer from "./snackbarSlice";
import textEditorReducer from "./textEditorSlice";
import storesReducer from './storesSlice';
import { apiSlice } from './apiSlice';
import { settingsApi } from './settingsApi';

const reducers = {
  auth: authReducer,
  alert: alertReducer,
  snackBar: snackBarReducer,
  textEditor: textEditorReducer,
  stores: storesReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
};

export default reducers;